const SITE_URL = process.env.REACT_APP_SITE_URL || "https://triptick.ai";
const DEFAULT_OG = `${SITE_URL}/images/metalogo.jpeg`;

export function buildCanonicalUrl(explicitCanonical, pathname) {
  if (explicitCanonical) return explicitCanonical;
  if (!pathname) return SITE_URL;
  return `${SITE_URL}${pathname}`;
}

export function buildAlternateLinks(pathname = "", canonicalUrl = SITE_URL) {
  const segments = pathname.split("/").filter(Boolean);
  const currentLang = segments[0];
  if (!["es", "en"].includes(currentLang)) {
    return [
      { hrefLang: "x-default", href: canonicalUrl },
      { hrefLang: "en", href: `${SITE_URL}/en` },
      { hrefLang: "es", href: `${SITE_URL}/es` },
    ];
  }

  const remainder = segments.length > 1 ? `/${segments.slice(1).join("/")}` : "";
  const altLang = currentLang === "es" ? "en" : "es";

  return [
    { hrefLang: currentLang, href: `${SITE_URL}/${currentLang}${remainder}` },
    { hrefLang: altLang, href: `${SITE_URL}/${altLang}${remainder}` },
    { hrefLang: "x-default", href: `${SITE_URL}/en${remainder}` },
  ];
}

export function buildDefaultOgImage() {
  return DEFAULT_OG;
}

export function buildBreadcrumbList(items = []) {
  if (!Array.isArray(items) || items.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url || `${SITE_URL}${item.path || ""}`,
    })),
  };
}

export function buildOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "TripTick",
    url: SITE_URL,
    logo: `${SITE_URL}/images/metalogo.jpeg`,
    sameAs: [
      "https://www.instagram.com/triptick.ai",
      "https://www.linkedin.com/company/triptick-ai/",
    ],
  };
}

export function buildWebAppSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "TripTick",
    applicationCategory: "TravelApplication",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      ratingCount: "128",
    },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "EUR",
    },
    operatingSystem: "Any",
    url: SITE_URL,
  };
}

export function buildItinerarySchema({ name, description, image, url, startDate, endDate, locations }) {
  return {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    name,
    description,
    image: image || buildDefaultOgImage(),
    url: url || SITE_URL,
    itinerary: Array.isArray(locations)
      ? locations.map((place, index) => ({
          "@type": "TouristAttraction",
          name: place.name,
          description: place.description,
          position: index + 1,
          url: place.url,
          geo: place.geo
            ? {
                "@type": "GeoCoordinates",
                latitude: place.geo.lat,
                longitude: place.geo.lng,
              }
            : undefined,
        }))
      : undefined,
    startDate,
    endDate,
  };
}

export function getSiteUrl() {
  return SITE_URL;
}

